/**
* Created by bieao on 2020/4/2.
*/
<template>
    <div class="item-position statistics-today">
      <div class="title-item">
        <div class="first"></div>
        <div class="two">04</div>
        <div class="title">
          <div>Statistics today</div>
          <div>{{$t('todayStatistics')}}</div>
        </div>
      </div>
      <div class="statistics-item m-b-10">
        <div class="statistics-title m-b-10">
          <div class="m-r-10">{{$t('todayOnlineRate')}}：</div>
          <div>{{Math.floor(data.currentOnlineRate)}}</div>
          <div>%</div>
        </div>
        <div class="statistics-rate">
          <div class="m-r-10">{{$t('dayToDay')}}</div>
          <div class="m-r-10 rate">{{!data.preOnlineRate ? '--' : `${(Math.abs(data.currentOnlineRate - data.preOnlineRate) / data.preOnlineRate * 100).toFixed(1)}%`}}</div>
          <div v-if="data.preOnlineRate"><i :class="[data.currentOnlineRate - data.preOnlineRate >= 0 ? 'el-icon-caret-top green':'el-icon-caret-bottom red']"></i></div>
        </div>
      </div>
      <div class="statistics-item m-b-10">
        <div class="statistics-title m-b-10">
          <div class="m-r-10">{{$t('todayAlarm')}}：</div>
          <div>{{data.currentAlarm}}</div>
          <div>{{$t('times')}}</div>
        </div>
        <div class="statistics-rate">
          <div class="m-r-10" v-if="data.preAlarm">{{$t('dayToDay')}}</div>
          <div class="m-r-10 rate" v-if="data.preAlarm">{{(Math.abs(data.currentAlarm - data.preAlarm) / data.preAlarm * 100).toFixed(1)}}%</div>
          <div class="m-r-20" v-if="data.preAlarm"><i :class="[data.currentAlarm - data.preAlarm >= 0 ? 'el-icon-caret-top red':'el-icon-caret-bottom green']"></i></div>
          <div class="m-r-10">{{$t('craneAvg')}}</div>
          <div class="m-r-10 rate">{{data.currentTaJunAlarm.toFixed(1)}}</div>
        </div>
      </div>
      <div class="statistics-item m-b-10">
        <div class="statistics-title m-b-10">
          <div class="m-r-10">{{$t('todayPeccancy')}}：</div>
          <div>{{data.currentPeccancy}}</div>
          <div>{{$t('times')}}</div>
        </div>
        <div class="statistics-rate">
          <div class="m-r-10" v-if="data.prePeccancy">{{$t('dayToDay')}}</div>
          <div class="m-r-10 rate" v-if="data.prePeccancy">{{(Math.abs(data.currentPeccancy - data.prePeccancy) / data.prePeccancy * 100).toFixed(1)}}%</div>
          <div class="m-r-20" v-if="data.prePeccancy"><i :class="[data.currentPeccancy - data.prePeccancy >= 0 ? 'el-icon-caret-top red':'el-icon-caret-bottom green']"></i></div>
          <div class="m-r-10">{{$t('craneAvg')}}</div>
          <div class="m-r-10 rate">{{data.currentTaJunPeccancy.toFixed(1)}}</div>
        </div>
      </div>
      <div class="statistics-item m-b-10">
        <div class="statistics-title m-b-10">
          <div class="m-r-10">{{$t('todayHoisting')}}：</div>
          <div>{{data.currentHangTimes}}</div>
          <div>{{$t('times')}}</div>
        </div>
        <div class="statistics-rate">
          <div class="m-r-10" v-if="data.preHangTimes">{{$t('dayToDay')}}</div>
          <div class="m-r-10 rate" v-if="data.preHangTimes">{{(Math.abs(data.currentHangTimes - data.preHangTimes) / data.preHangTimes * 100).toFixed(1)}}%</div>
          <div class="m-r-20" v-if="data.preHangTimes"><i :class="[data.currentHangTimes - data.preHangTimes >= 0 ? 'el-icon-caret-top red':'el-icon-caret-bottom green']"></i></div>
          <div class="m-r-10">{{$t('craneAvg')}}</div>
          <div class="m-r-10 rate">{{data.currentTaJunHangTimes.toFixed(1)}}</div>
        </div>
      </div>
      <div class="statistics-item">
        <div class="statistics-title m-b-10">
          <div class="m-r-10">{{$t('todayHours')}}：</div>
          <div>{{(data.currentWorkTime/3600).toFixed(1)}}</div>
          <div>h</div>
        </div>
        <div class="statistics-rate">
          <div class="m-r-10" v-if="data.preWorkTime">{{$t('dayToDay')}}</div>
          <div class="m-r-10 rate" v-if="data.preWorkTime">{{(Math.abs(data.currentWorkTime - data.preWorkTime) / data.preWorkTime * 100).toFixed(1)}}%</div>
          <div class="m-r-20" v-if="data.preWorkTime"><i :class="[data.currentWorkTime - data.preWorkTime >= 0 ? 'el-icon-caret-top red':'el-icon-caret-bottom green']"></i></div>
          <div class="m-r-10">{{$t('craneAvg')}}</div>
          <div class="m-r-10 rate">{{(data.currentTaJunWorkTime/3600).toFixed(1)}}&nbsp;h</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'StatisticsToday',
  props: {
    data: {
      type: Object
    },
    overview: {
      type: Object
    }
  }
}
</script>

<style scoped lang="scss">
  .statistics-today{
    left: 1660px;
    top: 20px;
    .statistics-item{
      width:250px;
      height:70px;
      background-size: 100% 100%;
      background: url('/static/img/item-bg300x70.png') center center no-repeat;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding:0 20px;
      .statistics-title{
        display: flex;
        align-items: flex-end;
        div:first-child{
          font-size: 18px;
        }
        div:nth-child(2){
          color:#49d5f3;
          font-size: 20px;
        }
        div:last-child{
          margin-left: 5px;
          font-size: 12px;
          color:#6282b4;
        }
      }
      .statistics-rate{
        display: flex;
        align-items:flex-end;
        font-size: 12px;
        .rate{
          color:#49d5f3;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StatisticsToday.vue